module.exports = __webpack_public_path__ + "static/assets/ff8804556fcc8ba98206e215ae034f29.png";